export default __webpack_public_path__ + "static/media/whatsapp.4ed63808.png";